"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = require("styled-components");

var d3 = _interopRequireWildcard(require("d3"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FONT_SIZE = 16;
var TEXT_Y = 21;
var BAR_HEIGHT = 30;
var BAR_TEXT_WIDTH_NORMAL = 50;

function determineColor(theme, level) {
  if (level == 'HIGH') {
    return theme.alert.ok;
  } else if (level === 'MEDIUM') {
    return theme.alert.warning;
  }

  return theme.alert.error;
}

var BarText = (0, _styledComponents.withTheme)(function (_ref) {
  var x1 = _ref.x1,
      x2 = _ref.x2,
      y = _ref.y,
      value = _ref.value,
      theme = _ref.theme;
  var isLeftAligned = x2 - x1 < BAR_TEXT_WIDTH_NORMAL;
  var dx = isLeftAligned ? 10 : -10;
  var fill = isLeftAligned ? theme.one[0] : theme.two[0];
  return /*#__PURE__*/_react.default.createElement("text", {
    x: x2 + dx,
    y: TEXT_Y,
    fill: fill,
    fontFamily: theme.font3,
    fontWeight: "900",
    fontSize: FONT_SIZE,
    textAnchor: isLeftAligned ? 'start' : 'end'
  }, value, "%");
});
var Bar = (0, _styledComponents.withTheme)(function (_ref2) {
  var fill = _ref2.fill,
      x1 = _ref2.x1,
      x2 = _ref2.x2,
      y = _ref2.y,
      value = _ref2.value,
      xmax = _ref2.xmax,
      theme = _ref2.theme;
  return /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("rect", {
    x: x1,
    y: y,
    width: xmax,
    height: BAR_HEIGHT,
    rx: "4",
    fill: theme.inverted.one[0]
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: x1,
    y: y,
    width: x2 - x1,
    height: BAR_HEIGHT,
    rx: "4",
    fill: fill
  }), /*#__PURE__*/_react.default.createElement(BarText, {
    x1: x1,
    x2: x2,
    y: y,
    value: value
  }));
});

var SingleBarChart = function SingleBarChart(_ref3) {
  var width = _ref3.width,
      value = _ref3.value,
      level = _ref3.level,
      theme = _ref3.theme;
  // horizontal draw scale 1 (value -> x-coordinate)
  var scaleX = d3.scaleLinear().range([0, width]).domain([0, 100]).nice(10); // render bars + bar background + bar text

  var originPx = scaleX(d3.min(scaleX.range())); // compose SVG element

  return /*#__PURE__*/_react.default.createElement("svg", {
    width: width,
    height: BAR_HEIGHT
  }, /*#__PURE__*/_react.default.createElement(Bar, {
    value: value,
    x1: originPx,
    x2: scaleX(value),
    xmax: width,
    y: 0,
    fill: determineColor(theme, level)
  }));
};

SingleBarChart.propTypes = {
  width: _propTypes.default.number.isRequired,
  value: _propTypes.default.number.isRequired,
  level: _propTypes.default.oneOf(['LOW', 'MEDIUM', 'HIGH']).isRequired
};

var _default = (0, _styledComponents.withTheme)(SingleBarChart);

exports.default = _default;
//# sourceMappingURL=SingleBarChart.js.map